module.exports = __webpack_public_path__ + "img/poster-pharmaceutic.251ea9f9.jpg";